import React, { useState } from "react";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import { IDesviacion } from "../../../../entities/IDesviacion";
import { IEstadoDesviacion } from "../../../../entities/IEstadoDesviacion";
import IGerencia from "../../../../entities/IGerencia";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import ISubContratista from "../../../../entities/ISubContratista";
import IUnidad from "../../../../entities/IUnidad";
import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import { API_ADMIN_DESVIACION, API_ADMIN_GERENCIA, API_ADMIN_UNIDAD, ROW_COUNT, URL_SUPPORT } from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import DesviacionService from "../../../../services/DesviacionService";
import VppService from "../../../../services/VppService";
import CscService from "../../../../services/CscService";
import CustomToast from "../../../../cross/CustomToast";
import { cParamsActive, cParamsActiveOrderTitle, cParamsActiveOrderNombre } from "../../../../helpers/paramsHelper";
import { updateFilter, updateSelectedField } from "../UtilsMantenedor";
import EstadoDesviacionService from "../../../../services/EstadoDesviacionService";
import { items as desv } from "../../../../test/variableTest";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";

const MySwal = withReactContent(Swal);

interface IMantenedorDesviacionesProps {
  items?: Array<any>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciaSubgerencia?: Array<IGerencia>;
  cbUnidadProyecto?: Array<IUnidad>;
  cbContratistaSubcontratista?: Array<ISubContratista>;
  cbEstadoDesviacion?: Array<IEstadoDesviacion>;
  itemsArrCambios?: Array<IConfirmacionMantenedor>;
  openPopUptest?: boolean;
  editColumn?: boolean;
  columnInfo?: any;
}

interface IPropsColumn {
  infoMD: any;
  token: string;
  currentUserMD: any;
  triggerReloadMD: any;
}

const ButtonDesactivar = (infoMD: any, token: any, currentUserMD: any, triggerReloadMD: any) => {
  let desactivar = infoMD.row.original.ACTIVO ? "Desactivar" : "Activar";
  return (
    <button
      className="btnIcono"
      title={desactivar}
      onClick={() => {
        MySwal.fire({
          html: (
            <div>
              <h3>
                ¿Desea {desactivar.toLowerCase()} el registro {infoMD.row.original.CORRELATIVO}?
              </h3>
            </div>
          ),
          text: "",
          icon: "question",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            MySwal.fire({
              html: (
                <div>
                  <h4>Ingrese un Motivo:</h4>
                </div>
              ),
              input: "textarea",
              inputAttributes: {
                autocapitalize: "off",
              },
              showCancelButton: true,
              confirmButtonText: `<i class="bi bi-eye"></i>${desactivar}`,
              cancelButtonText: "Cancelar",
              showLoaderOnConfirm: true,
              preConfirm: async (txtMotivo) => {
                if (!txtMotivo) {
                  Swal.showValidationMessage(`Debe ingresar un motivo`);
                } else {
                  await DesviacionService.desactivarRegistro(token, {
                    ID_REGISTRO: infoMD.row.original.ID as number,
                    AUTOR: currentUserMD?.email as string,
                    AUTOR_DISPLAY: currentUserMD?.fullname as string,
                    CAMPO: "N/A",
                    EDITOR: currentUserMD?.email as string,
                    EDITOR_DISPLAY: currentUserMD?.fullname as string,
                    MODULO: "DESVIACIONES",
                    TABLA: "DESVIACIONES",
                    MOTIVO: txtMotivo,
                    VALOR_INICIAL: "N/A",
                    DESACTIVAR: infoMD.row.original.ACTIVO as boolean,
                    FECHA_CREACION: new Date(),
                    FECHA_MODIFICACION: new Date(),
                    VALOR_FINAL: "N/A",
                    ACCION: desactivar.toUpperCase(),
                    CORRELATIVO: infoMD.row.original.CORRELATIVO,
                  });
                  await triggerReloadMD();
                }
              },
              allowOutsideClick: () => !Swal.isLoading(),
            }).then((result) => {
              if (result.isConfirmed) {
                console.log("");
              }
            });
          }
        });
      }}>
      <i className={infoMD.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
    </button>
  );
};

export default function MantenedorDesviaciones({
  items,
  columnInfo = undefined,
  editColumn = false,
  cbVicepresidencia,
  cbGerenciaSubgerencia,
  cbUnidadProyecto,
  cbContratistaSubcontratista,
  cbEstadoDesviacion,
  itemsArrCambios,
  openPopUptest,
}: IMantenedorDesviacionesProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfoToken = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUserMD, setCurrentUserMD] = useState<ICurrentUser>();
  const [comboVccMD, setComboVccMD] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboUPMD, setComboUPMD] = useState<Array<IUnidad>>(cbUnidadProyecto || []);
  const [comboGSGMD, setComboGSGMD] = useState<Array<IGerencia>>(cbGerenciaSubgerencia || []);
  const [comboCSCMD, setComboCSCMD] = useState<Array<ISubContratista>>(cbContratistaSubcontratista || []);
  const [comboEDMD, setComboEDMD] = useState<Array<IEstadoDesviacion>>(cbEstadoDesviacion || []);

  const [isEditColum, setIsEditColumMD] = useState<boolean>(editColumn);
  const [editColumnInfo, setEditColumnInfo] = useState<any>(columnInfo);
  const [listItemsMD, setListItemsMD] = useState<Array<any>>(items || []);
  const [pages, setPagesMD] = useState(0);
  const [page, setPageMD] = useState(1);
  const [showToast, setShowToastMD] = useState(false);
  const [hideTable, setHideTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [arrCambiosForm, setArrCambiosFormMD] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambios || []);
  const [isOpenPopUpGuardarCambios, setIsOpenPopUpGuardarCambiosMD] = useState<boolean>(openPopUptest || false);

  const refTxtCorr = React.createRef<HTMLInputElement>();
  const [refComboVccMD, setValComboVccMD] = useState<IComboboxOption | null>(null);
  const [refComboUPMD, setValComboUPMD] = useState<IComboboxOption | null>(null);
  const [refComboGSGMD, setValComboGSGMD] = useState<IComboboxOption | null>(null);
  const [refComboCSCMD, setValComboCSC] = useState<IComboboxOption | null>(null);
  const [refComboEDMD, setValComboED] = useState<IComboboxOption | null>(null);
  const [selectedField, setSelectedField] = useState({} as any);
  const refTxtMotivo = React.createRef<HTMLTextAreaElement>();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [isSendingData, setIsSendingData] = useState(false);

  const columnHelperMantDesviaciones = createColumnHelper<IDesviacion>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();
  const changeField = (id: string, valor: any) => {
    let sf: any = updateSelectedField(id, valor);
    setSelectedField(sf);
  };

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };
  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  let columnsDefMD = [
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      title: "Correlativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `DESV."CORRELATIVO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.ID, {
      id: "DESACTIVAR",
      cell: (infoMD: CellContext<IDesviacion, number>) => ButtonDesactivar(infoMD, token, currentUserMD, triggerReloadMD),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IDesviacion, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.ESTADO, {
      id: "ESTADO_COLUMNA",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Estado"),
      hide: false,
      title: "Estado",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `EV."NOMBRE"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.ASUNTO, {
      id: "ASUNTO",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Asunto"),
      hide: false,
      title: "Asunto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `DESV."ASUNTO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Vicepresidencia"),
      hide: false,
      title: "Vicepresidencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `VPP."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Gerencia Subgerencia"),
      hide: false,
      title: "Gerencia Subgerencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `GSG."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Unidad Proyecto"),
      hide: false,
      title: "Unidad Proyecto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `UP."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.CONTRATISTA_SUBCONTRATISTA, {
      id: "CONTRATISTA_SUBCONTRATISTA_COLUMNA",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Contratista SubContratista"),
      hide: false,
      title: "Contratista SubContratista",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `CSC."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.TIPO_DESVIACION, {
      id: "TIPO_DESVIACION",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Tipo Desviación"),
      hide: false,
      title: "Tipo Desviación",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `TD."NOMBRE"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.REQUISITO_NORMATIVO, {
      id: "REQUISITO_NORMATIVO",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(infoMD.getValue()),
      header: () => component("Requisito Normativo"),
      hide: false,
      title: "Requisito Normativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `RN."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.FECHA_DETECCION, {
      id: "FECHA_DETECCION",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentValue(shortDate(infoMD.getValue())),
      header: () => component("Fecha Detección"),
      hide: false,
      title: "Fecha Detección",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `DESV."FECHA_DETECCION"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.RESPONSABLE_INVESTIGACION_DISPLAY || rowMD.RESPONSABLE_INVESTIGACION, {
      id: "RESPONSABLE_INVESTIGACION",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentLink(infoMD.getValue()),
      header: () => component("Responsable Investigación"),
      hide: false,
      title: "Responsable Investigación",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfo(cell);
        setIsEditColumMD(true);
        setIsSendingData(false);
      },
      sortId: `DESV."RESPONSABLE_INVESTIGACION"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.RESPONSABLE_CIERRE_DISPLAY || rowMD.RESPONSABLE_CIERRE, {
      id: "RESPONSABLE_CIERRE",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentLink(infoMD.getValue()),
      header: () => component("Responsable Cierre"),
      hide: false,
      title: "Responsable Cierre",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfo(cell);
        setIsEditColumMD(true);
        setIsSendingData(false);
      },
      sortId: `DESV."RESPONSABLE_CIERRE"`,
    } as any),
    columnHelperMantDesviaciones.accessor((rowMD) => rowMD.AUTOR_DISPLAY || rowMD.AUTOR, {
      id: "AUTOR",
      cell: (infoMD: CellContext<IDesviacion, string>) => componentLink(infoMD.getValue()),
      header: () => component("Creado Por"),
      hide: false,
      title: "Creado Por",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfo(cell);
        setIsEditColumMD(true);
        setIsSendingData(false);
      },
      sortId: `DESV."AUTOR_DISPLAY"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfoToken;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUserMD(currUser);
    try {
      const comboVccMD = (await VppService.getAll(token, paramsActive)).result.data;
      setComboVccMD(comboVccMD);
      const comboCSCMD = (await CscService.getAll(token, paramsActive)).result.data;
      setComboCSCMD(comboCSCMD);
      let comboEDMD = await EstadoDesviacionService.getAll(token, cParamsActiveOrderNombre);
      comboEDMD = comboEDMD.filter((ed: any) => ed.ID != 5 && ed.ID != 6 && ed.ID != 7 && ed.ID != 9);
      setComboEDMD(comboEDMD);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const pagingMD = (page: any) => {
    setPageMD(page);
    filterMD({ PAGINA: page }, true);
  };

  const filterMD = (filterMD: any, page: boolean = false, size = pageSize) => {
    filterMD = updateFilter(filterMD, size, page);
    setPageMD(filterMD.PAGINA);
    if (filterMD.ORDENADOPOR.indexOf("_COLUMNA") > -1) {
      filterMD.ORDENADOPOR = filterMD.ORDENADOPOR.replace("_COLUMNA", "");
    }
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVccMD?.value;
    const valUP = refComboUPMD?.value;
    const valGSG = refComboGSGMD?.value;
    const valCSC = refComboCSCMD?.value;
    const valED = refComboEDMD?.value;
    filterMD.UNIDAD_PROYECTO = valUP;
    filterMD.GERENCIA_SUBGERENCIA = valGSG;
    filterMD.VICEPRESIDENCIA = valVcc;
    filterMD.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filterMD.ESTADO = valED;
    filterMD.CORRELATIVO = valCorr;

    getAPI(`${URL_SUPPORT}${API_ADMIN_DESVIACION}/getall`, { Authorization: `Bearer ${token}` }, filterMD)
      .then((result) => {
        setIsLoading(false);
        setListItemsMD(result.result.data);
        let pages = result.result.pages;
        setPagesMD(pages);
      })
      .catch((error) => {});
  };

  const editMD = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const triggerReloadMD = async () => {
    setIsLoading(true);
    const valCorr = refTxtCorr.current?.value === "Seleccione" ? "" : refTxtCorr.current?.value;
    const valVcc = refComboVccMD?.value === "Seleccione" ? "" : refComboVccMD?.value;
    const valUP = refComboUPMD?.value === "Seleccione" ? "" : refComboUPMD?.value;
    const valGSG = refComboGSGMD?.value === "Seleccione" ? "" : refComboGSGMD?.value;
    const valCSC = refComboCSCMD?.value === "Seleccione" ? "" : refComboCSCMD?.value;
    const valED = refComboEDMD?.value === "Seleccione" ? "" : refComboEDMD?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: `DESV."ID"`,
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
    };

    try {
      const result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_DESVIACION}/getall`, { Authorization: `Bearer ${token}` }, params)).result;
      setArrCambiosFormMD([]);
      let list = result.data;
      let pages = result.pages;
      setPagesMD(pages);
      setListItemsMD(list);
    } catch (e) {
      console.log(e);
    }
    setHideTable(false);
    setIsLoading(false);
  };

  const resultOk = (arr: Array<IConfirmacionMantenedor> | undefined = undefined) => {
    let arrDesviaciones: Array<IDesviacion> = items ?? [];
    let arrLogs: Array<ILogMantenedor> = [];
    const arrCambios = arr ?? arrCambiosForm;
    arrCambios.forEach((ac) => {
      if (!arrDesviaciones.find((d) => d.ID === ac.ID)) {
        arrDesviaciones.push(ac.OBJETO_REF);
      }
    });

    arrDesviaciones.forEach((d: any) => {
      arrCambios
        .filter((ac) => ac.ID === d.ID)
        .forEach((ac) => {
          let log: ILogMantenedor = {
            ID: null,
            MODULO: "DESVIACIONES",
            TABLA: "DESVIACIONES",
            ID_REGISTRO: d.ID,
            CAMPO: ac.CAMPO_EDITADO_ID,
            VALOR_INICIAL: ac.VALOR_ORIGINAL,
            VALOR_FINAL: null,
            MOTIVO: refTxtMotivo.current?.value || "",
            AUTOR: currentUserMD?.email || "",
            FECHA_CREACION: new Date(),
            EDITOR: "",
            FECHA_MODIFICACION: new Date(),
            AUTOR_DISPLAY: currentUserMD?.fullname || "",
            EDITOR_DISPLAY: "",
            CORRELATIVO: d.CORRELATIVO,
          };

          if (ac.TIPO === ITipo_Campo.user) {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
            d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
            log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
          } else {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          }
          arrLogs.push(log);
        });
    });

    let value = {
      LOG_MANTENEDOR: arrLogs,
      DESVIACIONES: arrDesviaciones,
    };

    postAPI(`${URL_SUPPORT}${API_ADMIN_DESVIACION}/MantenedorDesviacion`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        if (refTxtMotivo.current) {
          refTxtMotivo.current.value = "";
        }
        setArrCambiosFormMD([]);
        setIsOpenPopUpGuardarCambiosMD(false);
        setShowToastMD(true);
        let data = result.result.data;
        console.log(data);
        let params = { PAGINA: page };
        filterMD(params);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <section>
      <div className="rowMD">
        <button
          hidden={true}
          data-testid="test1"
          onClick={() => {
            changeField("1", "1");
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Desviaciones</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-infoMD bi bi-infoMD-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="rowMD mb-1 ajusteInput">
                <div className="col-6">
                  <Col>
                    <label>Búsqueda por Correlativo:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorr} className="form-control form-control-sm" />
                  </Col>
                </div>
              </div>
              <div className="rowMD mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Vicepresidencia:</label>
                  <Select
                    options={comboVccMD.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO })) as any}
                    placeholder="Seleccione"
                    value={refComboVccMD || ""}
                    isClearable={true}
                    onChange={async (e: any) => {
                      setValComboVccMD(e);

                      let paramsActive = {
                        ...cParamsActive,
                        VICEPRESIDENCIA: e?.value,
                      };
                      if (e?.value) {
                        const comboGSGMD = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;

                        setComboGSGMD([]);
                        setComboGSGMD(comboGSGMD);
                        setComboUPMD([]);
                      } else {
                        setComboGSGMD([]);
                        setComboUPMD([]);
                      }
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Gerencia/Subgerencia:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboGSGMD || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboGSGMD.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboGSGMD(e);
                      let paramsActive = {
                        ...cParamsActive,
                        NOMBRE_GERENCIA_SUBGERENCIA: e?.value,
                      };

                      if (e?.value) {
                        const comboUPMD = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;
                        setComboUPMD(comboUPMD);
                      } else {
                        setComboUPMD([]);
                      }
                    }}
                  />
                </Col>
              </div>
              <div className="rowMD mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Unidad Proyecto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboUPMD || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboUPMD.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboUPMD(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6"></Col>
              </div>
              <div className="rowMD mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Contratista/Subcontratista:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboCSCMD || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboCSCMD.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboCSC(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Estado Desviación:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboEDMD || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboEDMD.map((vcc) => ({ value: vcc.NOMBRE, label: vcc.NOMBRE }))}
                    onChange={async (e: any) => {
                      setValComboED(e);
                    }}
                  />
                </Col>
              </div>
              <div className="rowMD mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    data-testid="btnbuscar"
                    onClick={async () => {
                      triggerReloadMD();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      (refTxtCorr.current as HTMLInputElement).value = "";
                      setValComboVccMD(null);
                      setValComboUPMD(null);
                      setValComboGSGMD(null);
                      setValComboCSC(null);
                      setValComboED(null);
                      setListItemsMD([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  <button
                    hidden={true}
                    data-testid="testresult"
                    onClick={() => {
                      resultOk([
                        {
                          CAMPO_EDITADO: "",
                          CAMPO_EDITADO_ID: "",
                          ID: 1,
                          OBJETO_REF: desv.filter((d) => d.ID === 1),
                          TIPO: ITipo_Campo.user,
                          VALOR_NUEVO: "",
                          VALOR_ORIGINAL: "",
                          TABLA_EDITADA: "",
                        },
                        {
                          CAMPO_EDITADO: "",
                          CAMPO_EDITADO_ID: "",
                          ID: 2,
                          OBJETO_REF: desv.filter((d) => d.ID === 2),
                          TIPO: ITipo_Campo.text,
                          VALOR_NUEVO: "",
                          VALOR_ORIGINAL: "",
                          TABLA_EDITADA: "",
                        },
                      ]);
                    }}></button>
                  <button hidden={true} data-testid="testedit" onClick={() => editMD({}, undefined)}></button>
                  <button hidden={true} data-testid="testpaging" onClick={() => pagingMD({})}></button>
                  {arrCambiosForm.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambiosMD(true);
                      }}
                      data-testid="Guardar Cambios">
                      {" "}
                      <i className="bi bi-check"></i>Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="rowMD mb-1">
        <AdminLista
          reload={filterMD}
          items={[]}
          callback={editMD}
          data={listItemsMD}
          tipo={"MantenedorDesviaciones"}
          filter={filterMD}
          pagination={{ pages: pages, page: page, paging: pagingMD }}
          title=""
          hideAdd={true}
          hideExport={true}
          columnsDef={columnsDefMD}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filterMD(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>

      {editColumnInfo && (
        <Offcanvas
          show={isEditColum}
          onHide={() => {
            setIsEditColumMD(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfo.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="rowMD mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>{editColumnInfo && editColumnInfo?.getValue()}</div>
            </div>
            <div className="rowMD mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      id={editColumnInfo?.column?.id}
                      tipoCampo={editColumnInfo?.column.columnDef.tipo}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>
            <div className="rowMD mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  data-testid="testaceptar2"
                  onClick={() => {
                    let json = selectedField;
                    let arr = arrCambiosForm;
                    json = {
                      ID: editColumnInfo.row.original.ID,
                      CAMPO_EDITADO: editColumnInfo.column.columnDef.title,
                      CAMPO_EDITADO_ID: editColumnInfo.column.columnDef.id,
                      VALOR_ORIGINAL: editColumnInfo?.getValue(),
                      VALOR_NUEVO: editColumnInfo.column.columnDef.tipo === ITipo_Campo.user ? selectedField : editColumnInfo?.getValue(),
                      OBJETO_REF: editColumnInfo.row.original,
                      TIPO: editColumnInfo.column.columnDef.tipo,
                    };
                    if (
                      !isSendingData &&
                      json.VALOR_ORIGINAL !==
                        (editColumnInfo.column.columnDef.tipo === ITipo_Campo.user
                          ? json.VALOR_NUEVO[json.VALOR_NUEVO.ID + "_DISPLAY"]
                          : json.VALOR_NUEVO)
                    ) {
                      arr.push(json);
                      setArrCambiosFormMD(arr);
                      setIsEditColumMD(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColumMD(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambios && (
        <Offcanvas
          show={isOpenPopUpGuardarCambios}
          onHide={() => {
            setIsOpenPopUpGuardarCambiosMD(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="rowMD mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Desviaciones:</span>
            </div>
            <div className="rowMD mb-2">
              <AdminLista
                reload={filterMD}
                items={[]}
                callback={editMD}
                data={arrCambiosForm}
                tipo={"MantenedorDesviaciones"}
                filter={filterMD}
                pagination={{ pages: pages, page: page, paging: pagingMD }}
                title=""
                hideAdd={true}
                hideExport={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((rowMD) => rowMD.ID, {
                    id: "ID",
                    cell: (infoMD: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMD.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMD) => rowMD.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (infoMD: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMD.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMD) => rowMD.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (infoMD: CellContext<IConfirmacionMantenedor, string>) => componentValue(infoMD.getValue()),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowMD) => rowMD.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (infoMD: CellContext<IConfirmacionMantenedor, any>) => {
                      return componentValue(
                        infoMD.getValue()?.TIPO === ITipo_Campo.user ? infoMD.getValue()[`${infoMD.getValue().ID}_DISPLAY`] : infoMD.getValue()
                      );
                    },
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="rowMD mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivo} className="w-100"></textarea>
              </div>
            </div>
            <div className="rowMD mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  data-testid="testaceptar1"
                  onClick={() => {
                    if (!refTxtMotivo.current?.value) {
                      refTxtMotivo.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivo.current?.classList.remove("error");
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivo.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        resultOk();
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambiosMD(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="rowMD">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
